import { render } from "./DanhSachHoiNghi.vue?vue&type=template&id=a0409310&ts=true"
import script from "./DanhSachHoiNghi.vue?vue&type=script&lang=ts"
export * from "./DanhSachHoiNghi.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/NghienCuuKhoaHoc/NCKH_FontEnd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__